var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success-content"},[_vm._m(0),_c('div',{staticClass:"btn-box"},[_c('span',{staticClass:"back",on:{"click":_vm.goActivity}},[_vm._v("返回主页")]),_c('span',{staticClass:"order",on:{"click":_vm.goOrder}},[_vm._v("查看订单")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"success"},[_c('img',{attrs:{"src":require("../image/success.png"),"alt":""}}),_c('p',[_vm._v("支付成功")])])
}]

export { render, staticRenderFns }